/**
 * Commerce API Axios Instance
 *
 * Provides a configured axios instance with required headers for Commerce API requests.
 */

import { getLang } from "@hopper-b2b/i18n";
import axios, {
  type AxiosInstance,
  type CreateAxiosDefaults,
  type InternalAxiosRequestConfig,
} from "axios";

const createCommerceAxiosInstance = (
  config: CreateAxiosDefaults = {}
): AxiosInstance => {
  const clientId = import.meta.env.VITE_COMMERCE_PERKSPOT_CLIENT_ID;
  const instance = axios.create(config);

  instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    if (clientId) {
      config.headers.set("x-hopper-client-id", clientId);
    }

    const browserSessionId = sessionStorage.getItem("sessionId");
    if (browserSessionId) {
      config.headers.set("browser-session-id", browserSessionId);
    }

    const acceptLanguage = getLang();
    if (acceptLanguage) {
      config.headers.set("Accept-Language", acceptLanguage);
    }

    return config;
  });

  return instance;
};

export const commerceAxiosInstance = createCommerceAxiosInstance();
